import { Controller } from "stimulus";

export default class extends Controller
{

    ABORT_CONTROLLER = new AbortController();

    static targets = ["category", "reports", "report", "parameters", "title", "submit", "tables", "results", "loadingButton", "cancel"]

    connect()
    {
        this.categoryTargets.forEach(category => category.addEventListener("click", e =>
        {
            let index = category.dataset["index"];
            this.categoryTargets.forEach(cat => cat.classList.remove("selected"));

            category.classList.add("selected");

            this.reportsTargets.forEach(report => report.classList.add("hidden"));
            this.reportsTargets[parseInt(index)].classList.remove("hidden");
        }))

        this.reportTargets.forEach(report => report.addEventListener("click", e =>
        {
            let code = report.dataset["code"];

            report.classList.add("loading");
            fetch(window.App.prefixedUrl(`/view-data/parameters?code=${code}`))
            .then(data => 
            {
                if(!data.ok) throw new Error("Oops")
                return data.text()
            })
            .then(data =>
            {
                this.tablesTarget.innerHTML = "";
                this.reportTargets.forEach(r => r.classList.remove("selected"));
                report.classList.add("selected");

                let name = report.dataset["name"];
                this.titleTarget.innerText = name; 

                this.submitTarget.classList.remove("hidden");

                this.parametersTarget.innerHTML = data;
                this.parametersTarget.dataset["code"] = code;
                App.applyFlatpickr();

                history.pushState({ page: "data"}, report.dataset["name"] + " - View Data | usadealer.us", window.App.prefixedUrl("/view-data?f="+encodeURIComponent(report.dataset["name"])))
                document.title = report.dataset["name"] + " - View Data | usadealer.us"
            })
            .catch((e) =>
            {
                let toastEvent = new CustomEvent("show-toast", { detail: "An error occurred while loading the parameters." })
                window.dispatchEvent(toastEvent);
                
            })
            .finally(() =>
            {
                report.classList.remove("loading");
            })

        }))

        this.submitTarget.addEventListener("click", e =>
        {
            let form = this.parametersTarget.firstElementChild;
            
            if(!this.validate(form)) return;

            let data = new FormData(this.parametersTarget.firstElementChild);

            let body = {};

            data.forEach((val, key) => body[key] = val);
            body.url = this.parametersTarget.firstElementChild.action;
            body.code = this.parametersTarget.dataset["code"];

            this.submitTarget.classList.add("hidden");
            this.loadingButtonTarget.classList.remove("hidden");
            this.resultsTarget.classList.add("hidden");
            this.cancelTarget.classList.remove("hidden");

            fetch(body.url, {
                method: "POST",
                body: JSON.stringify(body),
                headers: { "content-type": "application/json" },
                signal: this.ABORT_CONTROLLER.signal
            })
            .then(res => 
            {
                return res.json()
            })
            .then(json =>
            {
                if(!json.success)
                {
                    let event = new CustomEvent("show-toast", { detail: "An error occurred:\n" + json.error });
                    window.dispatchEvent(event);

                    return;
                }

                this.tablesTarget.innerHTML = json.html;
                this.resultsTarget.classList.remove("hidden");
            })
            .finally(() =>
            {
                this.submitTarget.classList.remove("hidden");
                this.loadingButtonTarget.classList.add('hidden');
                this.cancelTarget.classList.add("hidden");
            })
        })

        this.cancelTarget.addEventListener("click", e =>
        {
            this.ABORT_CONTROLLER.abort();
            this.ABORT_CONTROLLER = new AbortController();
        })
        
    }

    validate(form)
    {
        let pass = true;

        let requiredFields = Array.from(form.querySelectorAll(`input`)).filter(x => x.required && x.dataset.validation);

        for(let i = 0; i<requiredFields.length; i++)
        {
            let field = requiredFields[i];
            if(!field.value)
            {
                let message = field.dataset["validation"];
                let event = new CustomEvent("show-toast", { detail: "An error occurred:\n"+message });
                window.dispatchEvent(event);

                pass = false;
                break;
            }
        }

        return pass;
    }
}